import { createEntityPickerField } from "./createEntityPickerField";
import type { TypedEntityPickerProps } from "./EntityPickerField";
import type { PayeeId } from "../../api/types";

export type PayeePickerFieldProps = TypedEntityPickerProps<PayeeId>;

export const PayeePickerField = createEntityPickerField<PayeeId>("payee");
